import { ReleaseNote } from "./shared/customHoooks/useUserReleaseNote";

export const releaseNoteData: ReleaseNote[] = [
  // // Example data
  // {
  //   version: "1.2.3",
  //   date: "11-Sep-2024",
  //   changes: [
  //     "Added feature A",
  //     "Fixed bug in feature B",
  //     "Improved performance for feature C",
  //   ],
  // },
  // {
  //   version: "1.2.2",
  //   date: "10-Sep-2024",
  //   changes: ["Fixed minor UI issue", "Updated documentation"],
  // },
  {
    version: "17.17.0",
    date: "30-09-2026",
    changes: [
      "Hourly Shapes products are now available, these products cover segmented time blocks across the day, including the following:",
      "Morning (MN) - Midnight to 6am",
      "Morning Peak (MP) - 6am to 10am",
      "Daytime (DY) - 10am to 4pm",
      "Evening Peak (EP) - 4pm to 8pm",
      "Evening (EV) - 4pm to 10pm",
      "Nighttime (NT) - 8pm to 12am",
      "End of Day Benchmarks are available within the the Power Benchmarks collection covering Calendar Year, Financial Year and Quarterly tenors.",
      "Premium Power (aka electricity) market and Asset Intelligence subscribers now have access to these Product Types and Benchmarks, including through the Chart Builder feature.",
      "Stay tuned for more updates to the Power market product catalogue - with Heads & Tails contracts coming in the coming weeks; if you are interested in broadening your subscription access for these products, contact us using our feedback form located in the menu via your user profile icon at top right of screen.",
    ],
  },
  {
    version: "17.15.0",
    date: "23-09-2026",
    changes: [
      "Daily curves have been updated to Benchmarks across the platform.",
      "Renewable Electricity Guarantee of Origin Certificates (REGO) product types have been added to the platform with an End of Day Benchmark data available in the coming days.",
      "Australian Power market Benchmarks have been consolidated to a single view (ASX Futures, Fixed Shapes and soon to come Hourly Shapes.",
      "Australian Power market End of Day Benchmark notifications have been consolidated to a single notification for the range or product classes in line with the user interface change mentioned above).",
      "Asset Intelligence’s Benchmarks & Commentary section has been renamed to Market Dynamics to improve the alignment and consistency for additional new content and features that are coming in the near future.",
      "Asset Intelligence Market Tracker content now includes Lifecycle Duration and Capacity Pipeline charts where you can assess the state of the asset development pipeline in fine detail. These charts are also available as widgets for use in the Dashboards feature for premium subscribers.",
      "Asset Intelligence’s Contract Capacity chart has been revamped to provide clearer information and more granular information breakdowns – this can be found within the Market Dynamics section and also as a Dashboard widget for premium subscribers.",
      "Asset Intelligence Explorer view has been updated to include various bubble maps for asset performance. These are available on map view from the Asset Layers section.",
      "Along with the above, asset tooltips (when hovering on map markers) now include a summary of performance stats for operational assets; and a checklist of approval statuses for planning assets.",
      "Explorer now includes an additional technology filter condition, allowing you to exclude selected technologies from the view (across map, card and table views).",
      "Added additional column options in Explorer table view (you can add and remove columns from the column selection menu (icon button) located at the top right of the table, including planning project approval status and a number of operational stats.",
      "Updated the planning sub filters to include the pending and approved status options",
      "Improved the hover interaction with transmission lines and other similar line based overlays to make it easier to hover and select them.",
      "Added new analysis categories to the Market Dynamics section (previously known as Benchmarks & Commentary), providing more insights for each quarterly publication. Expect new information for the upcoming Q3 release.",
      "Improved load time performance of the Market Dynamics layers on Explorer's map view.",
      "Chart Builder (and charts more broadly across the platform) have received some long-anticipated updates!",
      "All charts can now be viewed in full screen and Chart Builder configurations now supports functionality allowing you to select trace style preferences for each data type within a chart – we also have more improvements coming for this capability too!",
      "Added grouped data selections for the Chart Builder NEM - SCADA section - this provides selections for NEM, State and Technology aggregated generation outputs. The data is currently included up to the end of previous day - with improvements coming to bring this inline with current interval.",
      "A number of underlying fixes and performance improvements across the platform.",
    ],
  },
  {
    version: "17.8.0",
    date: "26-08-2026",
    changes: [
      "Added ability to filter on various approval status for planning projects (implementation also coming soon).",
      "Added undersea fibre cable infrastructure layer for the Explorer map (land based lines also coming soon).",
      "Further improved performance of asset generation and revenue charts.",
      "Improved sorting defaults for card view sorting options.",
      "Elevated Access Rights Schemes filter on Explorer to be found at the top level of the Schemes and Tenders section.",
      "Fixed various theme, interaction and layout problems across the platform",
    ],
  },
  {
    version: "17.3.0",
    date: "06-Aug-2026",
    changes: [
      "Added ability to filter assets by scheme and tender.",
      "Updated layout of development attributes tab.",
      "Moved KCI related data points to the development attributes tab.",
      "Improved performance of asset generation charts.",
      "Improved sorting and layout of asset documents and references.",
      "Fixed missing certificate revenue calculations on some projects.",
      "Fixed an issue where the market dynamics data was not displaying the correct period based on the selection.",
    ],
  },
  {
    version: "17.0.0",
    date: "27-Jul-2026",
    changes: [
      "Today we're launching Asset Intelligence, a new platform capability that brings together renewable energy project information, power market context and commercial analysis in one place.",
      "Discover new project opportunities and screen assets through Explorer, with GIS, grid, transmission, Renewable Energy Zone, planning and market overlays in a single view.",
      "Dive into Asset Information for a deeper view of individual assets, including development status, approvals, ownership, network connection, generation data, certificate registry information, offtake context and supporting records.",
      "Model different revenue, pricing, offtake and risk outcomes in Scenario Analysis to better understand the commercial outlook for an asset or portfolio.",
      "Build custom Portfolios to shortlist opportunities, create benchmarks, compare assets and assess project outcomes as a group.",
      "Jump into Market Dynamics to explore contract benchmarks, PPA activity, market trends and commercial insights that support investment, development and origination decisions.",
      "Stay on top of asset performance and market movements through Market Tracker, with regularly updated performance rankings, development pipeline status, generation insights and technology trends.",
      "Visit Offtake Tracker to explore publicly announced offtake agreements and key statistics.",
      "NOTE: An introductory version is currently available to all users for a limited time. Full functionality is available to subscribed users only. This product is offered as an add-on to existing subscription packages.",
    ],
  },
  {
    version: "16.70.0",
    date: "18-May-2026",
    changes: [
      "The layout for Electricity curves (ASX Futures) has been updated to reflect previous changes in the market.",
      "Qld, SA and Vic Peak products have been removed from the table's layout, this is a user interface change only.",
      "'NSW Peak' remains the only region to continue receiving a daily curve price for the Peak product type.",
      "'$300 Cap’ products have been added to the layout (and also now available via API), going forward a daily curve will be set for NSW, Qld, SA and Vic regions.",
      "The historic data set for all Peak product curves remain available through Chart Builder, and directly from the benchmarks API for users accessing the data in that way.",
    ],
  },
  {
    version: "16.51.0",
    date: "30-Jan-2026",
    changes: [
      "Market updates and insights previously published on the CORE Markets website are now accessed directly inside the CORE Markets platform.",
      "We’ve updated the Insights section to make content easier to find, with dedicated areas for: Market updates / Articles / Premium reports (subscription required).",
      "We’ve also improved notification preferences, giving you more control over which markets and content types you receive updates for. You can review and update your preferences at any time inside the platform from your profile page.",
    ],
  },

  {
    version: "16.33.0",
    date: "31-Oct-2025",
    changes: [
      "Just in time for Halloween, dark mode is here!",
      "You can now choose your preferred display theme across the CORE Markets platform. Options include the CORE Markets default theme, as well as new light and dark themes.",
      "You can also choose ‘Device theme’, which will automatically match your device’s light or dark mode settings, including if your device switches modes during the day.",
      "To change your theme, open the user panel in the top right corner of the screen and click the 'Default theme' menu item to cycle through the available options.",
      "You can also update your preference in your user profile under the Preferences tab. This section also includes several new personalisation options added in recent releases.",
    ],
  },
  {
    version: "16.26.0",
    date: "08-Oct-2025",
    changes: [
      "Updates to the ACCU curve price structure are now live.",
      "These updates include monthly contract price points for generic and method-specific ACCU price curves - complementing existing Spot and Calendar Year contract periods.",
      "These new price inclusions are available across the platform and via the Daily Curves API for those who have data integrations with us.",
      'The Daily Curves API endpoint has been updated to provide greater flexibility and now allows for calling a specific "product type" (eg: accu, lgc, smc etc.). The existing "type" parameter is still available for continues use. Refer to the API help docs for more information.',
      "Trade Timeline has been updated to provide clearer segmentation and filtering of trade types.",
      "Support for additional trade types has been added, including Collars, Spreads and Swaps. These can be filtered using the trade type selection found on the page.",
      "Strip trades have also been elevated to a distinct trade type, making it possible to filter specifically for these trades.",
      "Trade Timeline API help documentation has been updated to include information on the new parameters available for the endpoint.",
      "Additional UI preferences and navigation functionality have also been rolled out.",
      "You can now configure how you see data tables across the app with global settings for view density (3 options) and banded row styling controls.",
      "The main menu that provides app wide navigation has been updated to permanently remember its position (e.g. expanded or collapsed), so that when collapsed, the full menu now appears on hover for easier navigation.",
      "Go to your user profile to view and adjust any of these preferences.",
    ],
  },
  {
    version: "16.12.0",
    date: "09-Jul-2025",
    changes: [
      "Platform preferences are here! Visit your user profile to set your preferred user interface (UI) preferences.",
      "These currently include volume formatting, 'relative' date time controls and the ability to set and update your default homepage.",
      "More preference are in the works, including themes, localisations, and additional accessibility settings; stay tuned for more.",
    ],
  },

  {
    version: "16.5.0",
    date: "04-Jun-2025",
    changes: [
      "ACCU Plantation Forestry method is now available across the platform.",
      "The Plantation Forestry method code is displayed as 'PLFR'.",
      "Plantation Forestry data includes live prices, trade history and benchmarks.",
    ],
  },

  {
    version: "16.0.0",
    date: "13-May-2025",
    changes: [
      "CORE Markets platform notifications are now available!",
      "Email and in-app notifications for a wide range of markets and insights content are now available to you; including trade reports, live prices, publications, and more.",
      "You can opt-in or out of any of these notifications by navigating to your profile in the ‘My details’ menu (via the username button found at the top right of screen) and configuring your preferences.",
      "Anyone previously receiving trade reports and other content directly from our Markets Team will continue to receive those emails. Your notifications preferences have been set in your user profile based on what you were already receiving.",
      "Live price notifications (bids and offer prices) are available for premium subscribers only. If you would like to upgrade your subscription to receive these alerts – visit the notification settings page in your user profile and request an upgrade.",
      "Emissions Manager has a new feature called ‘To dos’.",
      "You can add ‘To dos’ for any of your portfolios, initiatives and offsets with the ability to assign yourself or other team platform users to that 'To do' item.",
      "Additionally, Emissions Manager now includes notifications for various activity across your portfolios. You can also configure these notifications from your user profile.",
    ],
  },
  {
    version: "15.21.0",
    date: "31-Mar-2025",
    changes: [
      "LGC and STC REC Registry holdings data is now available within the platform. This information is updated daily and can be found in the Australian environmental market section under the registry tab.",
      "The Registry holdings table's configuration can be customised to your needs, with powerful column grouping controls and an array of filtering options that allow you to fully interrogate the data by attributes including owner, location, project, vintage, status and more.",
      "Brokerage clients can now access their trade transaction history with our markets team by opening your user profile panel and selecting the 'Transaction history' menu option.",
      "The mark as homepage button can now be deselected to change your custom home page preference back to the default CORE Markets Home page.",
      "Report pages have been updated to include an interactive table of contents. Click an item in the contents list to immediately jump to that location in the report.",
      "Bespoke reports have been integrated into the main reports pages and content feeds, instead of being found on a separate page.",
    ],
  },
  {
    version: "15.17.0",
    date: "07-Mar-2025",
    changes: [
      "Safeguard Mechanism Credits (SMCs) are now featured across the platform.",
      "SMC live pricing and other information can be found on on the 'Carbon Australia Overview' page.",
      "SMC end of day commentary and benchmark pricing has been added to the 'Carbon Daily Curve' page.",
      "SMC trade information is now available on the 'Trade Timeline' page and dashboard widget.",
      "SMC data is also available in 'Chart builder' and included in other various preset pricing dashboard widgets.",
      "Daily curve tables and widgets have received a visual update, along with the inclusion of change direction indicators for the data contained within.",
      "ACCU daily curve's method label now displays as the CORE Markets method code, hover your mouse on these column label to see the full name.",
    ],
  },
  {
    version: "15.10.0",
    date: "31-Jan-2025",
    changes: [
      "The new Australian Power Overview page is now available for electricity market subscribers, this page provides pricing and other information for both physical and financial products relating to Australia's NEM.",
      "Resolved an error that prevented the 'Mark as homepage' functionality from working correctly for some users.",
      "Fixed dashboard widget behaviour so that when changing the widget options it no longer moves to the bottom of the page.",
      "Fixed the display date bug for trades in the trade timeline dashboard widget and global homepage element.",
    ],
  },
  {
    version: "15.0.0",
    date: "29-Nov-2024",
    changes: [
      "This update brings a major revision to the way you can find markets information across the app.",
      "The new ‘Markets’ section replaces ‘Market Prices’ and unifies market data including live pricing, benchmarks and trade timeline into a common navigable location.",
      "Within ‘Markets’ each product class is populated with geographic markets providing all relevant information in a consolidated manner.",
      "Key features including ‘Project Marketplace’ and ‘Chart Builder’ have been elevated to top level elements in the main menu panel for easier access.",
      "‘Trade log’ has been renamed to ‘Trade timeline’ and is now located in the Markets section. The capability of this feature has been increased significantly, allowing you to organise the data how you prefer, including: grouping by attributes, re-ordering the columns, show or hide columns that are not relevant to you and adjust the row density to your preference.",
    ],
  },
  {
    version: "14.0.0",
    date: "15-Nov-2024",
    changes: [
      "Introducing the global ‘CORE Markets home’ page. This page showcases the latest live pricing and insights from our Markets and Advisory teams.",
      "The ‘Mark as favourite’ dashboard functionality has been upgraded to ‘Mark as homepage’. You can now select any page that features a home icon (found on the top right of the page) to be your landing page each time you log in.",
      "The CORE Markets ‘Insights’ section is now available. You can access premium content – including reports, market updates and other insights from our experts.",
      "ACCU Market Forecast subscribers can now access quarterly releases of this report via the ‘Reports’ page.",
      "Create dashboards quickly and easily with a selection of new templates found using the ‘Create New’ dashboard menu button.",
      "Select from a range of new and improved dashboard widgets that will power-up your custom dashboards experience.",
      "Visit the new ‘Markets snapshot’ page to see live pricing across a range of the most active products in market.",
    ],
  },
];
